
document.addEventListener('DOMContentLoaded', function() {
    initializeAccordions();
});

function initializeAccordions() {
    const accordions = document.querySelectorAll('.accordion-conditions');
    
    accordions.forEach((accordion) => {
        accordion.addEventListener('click', function() {
            toggleAccordion(this);
        });
    });
}

/**
 * Toggle accordion panel open/closed
 * @param {HTMLElement} accordion - The accordion button element
 */
function toggleAccordion(accordion) {
    accordion.classList.toggle('active-conditions');
    
    const panel = accordion.nextElementSibling;
    
    if (panel.style.maxHeight) {
        // Close the panel
        panel.style.maxHeight = null;
        panel.style.paddingBottom = '0px';
    } else {
        // Open the panel
        panel.style.maxHeight = panel.scrollHeight + 18 + 'px';
        panel.style.paddingBottom = '18px';
    }
}

if (typeof module !== 'undefined' && module.exports) {
    module.exports = { initializeAccordions, toggleAccordion };
}